module.exports = __webpack_public_path__ + "img/2.12ca5ad8.jpg";